import { render, staticRenderFns } from "./RegistroProductos.vue?vue&type=template&id=69368e7a"
import script from "./RegistroProductos.vue?vue&type=script&lang=js"
export * from "./RegistroProductos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports